/* eslint-disable import/prefer-default-export */

import api, { apiInternal } from '../api';


export async function getTag() {
  const result  = await api.post(`${apiInternal}/getTags`, {});
  if (result) return result.data
  return result;
}

export async function setTag(params) {
  const result = await api.post(`${apiInternal}/setTag`,params);
  if (result && result.data) return true;
  return false;
}